__turbopack_context__.v({
  "intro": "TimezoneToggle-module-scss-module__kJrq3G__intro",
  "primary": "TimezoneToggle-module-scss-module__kJrq3G__primary",
  "secondary": "TimezoneToggle-module-scss-module__kJrq3G__secondary",
  "station": "TimezoneToggle-module-scss-module__kJrq3G__station",
  "timezone": "TimezoneToggle-module-scss-module__kJrq3G__timezone",
  "timezone_toggle": "TimezoneToggle-module-scss-module__kJrq3G__timezone_toggle",
  "timezone_toggle__btn": "TimezoneToggle-module-scss-module__kJrq3G__timezone_toggle__btn",
  "toggle_bg": "TimezoneToggle-module-scss-module__kJrq3G__toggle_bg",
});
